import { CancelOutlined } from '@mui/icons-material';
import { Button, ButtonOwnProps, IconButton, Stack, StackProps, SvgIconProps } from '@mui/material';
import { closeSnackbar, SnackbarKey } from 'notistack';
import React from 'react';
import TooltipHardened from './TooltipHardened';

interface SnackButtonProps {
  snackKey: SnackbarKey;
  label: string;
  color?: ButtonOwnProps['color'];
  icon?: React.ComponentType<SvgIconProps>;
  onClick?: (snackKey: SnackbarKey) => void;
  dismiss?: boolean;
}

export const SnackbarButton = ({
  snackKey,
  label,
  onClick,
  dismiss,
  color,
  icon: Icon,
}: SnackButtonProps): React.JSX.Element => {
  const clickCallback = () => {
    if (onClick !== undefined) {
      onClick(snackKey);
    }
    if (dismiss === true) {
      closeSnackbar(snackKey);
    }
  };

  const buttonProps = { color: color ?? 'primary', onClick: clickCallback };

  if (Icon !== undefined) {
    return (
      <IconButton {...buttonProps}>
        <TooltipHardened tooltip={label}>
          <Icon />
        </TooltipHardened>
      </IconButton>
    );
  }

  return <Button {...buttonProps}>{label}</Button>;
};

/**
 * Always includes the dismiss button at the end.
 */
export const snackbarActionStack = (
  snackKey: SnackbarKey,
  actions?: Omit<SnackButtonProps, 'snackKey'>[],
  direction?: StackProps['direction'],
): React.JSX.Element => (
  <Stack direction={direction ?? 'row'}>
    {actions &&
      actions.map((actionProps, index) => <SnackbarButton key={index} snackKey={snackKey} {...actionProps} />)}
    <SnackbarButton
      dismiss
      color="inherit"
      icon={CancelOutlined}
      label={'dismiss'}
      key={'snack-dismiss-button'}
      snackKey={snackKey}
    />
  </Stack>
);
